import { createSlice } from "@reduxjs/toolkit";
import { SurfaceCleanerProduct } from "../../Api/Api"; // Import API function

const surfaceCleanerSlice = createSlice({
    name: "surfaceCleaner",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(SurfaceCleanerProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(SurfaceCleanerProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(SurfaceCleanerProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default surfaceCleanerSlice.reducer;
